// Each module declares its drill ladder once (§5). Leaf = all path fields filtered.

export const FIELD_LABELS = {
  month: "Month",
  period: "Period",
  type: "Movement Type",
  segment: "Segment",
  region: "Region",
  rep_id: "Rep",
  account_id: "Account",
  deal_id: "Deal",
  stage: "Stage",
  cohort: "Cohort",
  cost_center: "Cost Center",
  account: "GL Account",
  invoice_id: "Invoice",
  product: "Product",
  vendor: "Vendor",
};

export const MODULES = {
  arr: {
    title: "ARR Movements",
    table: "fact_arr_movement",
    measure: "SUM(amount)",
    format: "currency",
    path: ["month", "type", "segment", "account_id"],
    altDims: ["month", "type", "segment", "region", "account_id"],
    idField: "movement_id",
    leafLabel: "ARR movement event",
  },
  productivity: {
    title: "Closed Won Bookings",
    table: "fact_bookings",
    baseFilters: { status: "won" },
    measure: "SUM(amount)",
    format: "currency",
    path: ["segment", "region", "rep_id", "deal_id"],
    altDims: ["segment", "region", "rep_id", "account_id", "month"],
    idField: "deal_id",
    leafLabel: "closed deal",
  },
  pipeline: {
    title: "Pipeline",
    table: "fact_bookings",
    measure: "SUM(amount)",
    format: "currency",
    path: ["stage", "segment", "rep_id", "deal_id"],
    altDims: ["stage", "segment", "region", "rep_id", "account_id"],
    idField: "deal_id",
    leafLabel: "opportunity",
  },
  unitEcon: {
    title: "Revenue Lines",
    table: "fact_invoice_line",
    measure: "SUM(amount)",
    format: "currency",
    path: ["segment", "cohort", "account_id", "invoice_id"],
    altDims: ["segment", "cohort", "region", "account_id", "product", "period"],
    idField: "line_id",
    leafLabel: "invoice line",
  },
  pnl: {
    title: "General Ledger",
    table: "fact_gl",
    measure: "SUM(amount)",
    format: "currency",
    path: ["period", "cost_center", "account"],
    altDims: ["period", "cost_center", "account", "account_type", "vendor"],
    idField: "entry_id",
    leafLabel: "GL journal line",
  },
};
